﻿export class LanguageColumns {
    static columnsKey = 'Administration.Language';
}
